<template>


  <div class="dark">
               <InsideBanner />
		<h1 class="inside_page_name">Artwork</h1>
    <div class="piece-list">

          <PiecesCard :pieces='loadedPieces' :rowNum="rowNum" @refresh="loadedPieces()"/>

      </div>
    </div>
</template>

<script>
import PiecesCard from "@/components/PiecesCard.vue";
import InsideBanner from "@/components/InsideBanner.vue";

export default{
  components: {
    InsideBanner,
    PiecesCard
  },
  data() {
  return {
    rowNum: 3,
}
},
  computed: {

    loadedPieces() {
      return this.$store.getters.loadedPieces
    }
  },
}
</script>


